<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="page-user-view">

  
      <div id="user-data" >
        <!-- {{"Permissao adicionar "+canAddEmp}} -->
      
  
     
        <vx-card title="">
  
          <div class="block overflow-x-auto">
           
  
  <vs-table  stripe v-model="selected"  search :data="employees">
  <template  slot="header">
            <v-select
               :options="['5','10','20','50']"
               v-model="quant"
                >
                </v-select>
            </template>
      <template slot="thead">
    
        <vs-th sort-key="entry_date">Data</vs-th>
        <vs-th sort-key="entry_date">Estado</vs-th>
        <vs-th sort-key="entry_date">Nota</vs-th>
        <vs-th></vs-th>
      </template>
  
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
  
          <vs-td :data="data[indextr].entry_date">
            {{ data[indextr].date }}
          </vs-td>
         
          <vs-td>
            <vs-chip v-if="data[indextr].status=='reprovado'" class="font-bold whitespace-no-wrap">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-danger'"></div>
                          <span>{{data[indextr].status }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].status=='aprovado'" class="font-bold whitespace-no-wrap">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-success'"></div>
                          <span>{{data[indextr].status }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].status=='pendente'" class="font-bold whitespace-no-wrap">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-warning'"></div>
                          <span>{{data[indextr].status }}</span>
                      </vs-chip>
  
          </vs-td>
          <vs-td >
              <vs-chip v-if="data[indextr].note=='presente'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='presente'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-success'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
          
              <vs-chip v-if="data[indextr].note=='ausente'" class="font-bold" :data="data[indextr].note=='ausente'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-danger'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
           
              <vs-chip v-if="data[indextr].note=='justificada sem compesação'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='justificada sem compesação'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-warning'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
              <vs-chip v-if="data[indextr].note=='justificada com compesação'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='justificada sem compesação'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='licença'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='licença'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='férias'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='férias'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='atrasado'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='atrasado'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='trabalho de campo'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='trabalho de campo'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='antecipado'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='antecipado'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
          </vs-td>
        
         
  <vs-td>
     <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
         
                      <vs-button  class="mr-3" color="success" size="small"  type="border" @click="openDetalhes(tr)"> Ver Detalhes</vs-button>
  
                     
               
                <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              </vs-td>
  </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination class="mt-3" :total="totalPage" @change="getEmployees" v-model="currentPage"></vs-pagination>
  
  <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    <!-- <pre> {{ selected }} </pre> -->
  
          </div>
          <div class="vx-row">
        <!-- <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto  mt-2" type="border" color="warning"  @click="clean">Limpar</vs-button>
            <vs-button class="ml-4 mt-2" @click="saveMarcar" >Marcar</vs-button>
          </div>
        </div> -->
      </div>
  
         
  
        </vx-card>
         
      </div>
  
  
  <vs-popup class="holamundo" title="Justificação" :active.sync="popupAprovar">
   
  
   
         <div class="vx-row">
             <div class="vx-col w-full  mt-5 mb-5" >
    <label for="" class="text-lg font-bold">Motivo: </label> <span class="ml-1">{{justificacao.descrition}}</span>
    <hr>
           <label for="" class="font-bold text-lg">Nota: </label>
       <span class="ml-5">{{justificacao.note}}</span>    
            </div>
            
             
            <div class="vx-col w-full mb-5" >
           <!-- <img class="w-full" :src="justificacao.attachment" alt=""> -->
             <vs-button v-if="justificacao.attachment"  class="w-full"  color="success" iconPack="feather"
              icon="icon-download" target="_blank" :href="justificacao.attachment">Baixar Comprovativo</vs-button>
            </div>
      
            
           
          </div>
  
  
      </vs-popup>
    
  
    </div>
  </template>
  
  <script>
  import http from '../../../../http-common';
  import vSelect from 'vue-select'
  import { PermissionsMixin } from '../../../mixins/permissions';
  export default {
    mixins:[PermissionsMixin],
      components: {
      vSelect
    },
    data() {
      return {
        userId:"",
        name:"",
        surname:"",
        totalPage:"",
        currentPage:"1",
        paginate:50,
        dataEntrada:"",
        dataSaida:"",
        estado:"",
        quant:10,
       users:[],
       selectedUser:"",
       err:"",
  employees:[],
  popupUpBaixar:false,
  exit_date:"",
  exit_time:"",
  popupAprovar:false,
  justificacao:[],
     
        result:[],
  employee_id:[],
  attendance_id:[],
  entry_date:"",
  note:"",
  
  selected: [],
        'tableList': [
          'vs-th: Component',
          'vs-tr: Component',
          'vs-td: Component',
          'thread: Slot',
          'tbody: Slot',
          'header: Slot'
        ],
        
  
      }
    },
  
    
      computed: { //todo: descontinuei essa parte veja o watch e o metodo verifypermissions
        // canListEmp(){
        //   for(let permission in this.selectedUser.permissions){
        //     console.log("permissao", this.selectedUser.permissions[permission].name)
        //     if(this.selectedUser.permissions[permission].name == "list Employee"){
        //       return true;
        //     }
        //   }
        //   return false;
        // },
        // canAddEmp(){
        //   for(let permission in this.selectedUser.permissions){
        //     console.log("permissao", this.selectedUser.permissions[permission].name)
        //     if(this.selectedUser.permissions[permission].name == "create Employee"){
        //       return true;
        //     }
        //   }
        //   return false;
        // }
      },
  
      mounted() {
        this.getCurrentUser();
      this.initialize();
      this.verifyPermissions();
    
    },
  
    methods: {
      initialize(){
        this.getEmployees();
      },

      getCurrentUser(){
      
      let authUser = localStorage.getItem('empId');
      var authUserObject = JSON.parse(authUser);

    
 
       this.userId = authUserObject.id;
    //    this.id = authUserObject.id;
  
    },
     
     openDetalhes(attendance){
  
     this.popupAprovar=true
     this.justificacao= attendance
  
     },
  
  clean(){
    this.exit_date="",
    this.exit_time=""
  },
  
  
  mapear(){
  this.result = this.selected.map(person => (person.attendance_id ));
  },
  

  
   getEmployees() {
         this.$vs.loading({
          container: '#div-with-loading',
          scale: 1.0,
          type:'sound'
        })
       
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
            params: {
                          type: 1,
                          // entry_date:this.entry_date,
                          page:this.currentPage,
            paginate:this.paginate,
            employee_id:this.userId
                      },
            
        };
        
        
        http
          .get("/attendances/absence_justifications", config)
          .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.employees = result.data.Justifications.data
            this.currentPage="1",
            this.totalPage = result.data.Justifications.last_page;
            this.total =  result.data.Justifications.total;
          })
          .catch((error) => {
            error;
            if(error.response.status==401 ){
              this.$router.push('/').catch(() => {})
            }
           
          });
      },
  
  
  
  
    
  
    
  },
  
  
  }
  
  </script>
  
  <style lang="scss">
  #avatar-col {
    width: 10rem;
  }
  
  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .8rem;
        word-break: break-all;
      }
  
      &:not(.permissions-table) {
        td {
          @media screen and (max-width:370px) {
            display: block;
          }
        }
      }
    }
  }
  
  // #account-info-col-1 {
  //   // flex-grow: 1;
  //   width: 30rem !important;
  //   @media screen and (min-width:1200px) {
  //     & {
  //       flex-grow: unset !important;
  //     }
  //   }
  // }
  
  
  @media screen and (min-width:1201px) and (max-width:1211px),
  only screen and (min-width:636px) and (max-width:991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  
    // #account-manage-buttons {
    //   width: 12rem !important;
    //   flex-direction: column;
  
    //   > button {
    //     margin-right: 0 !important;
    //     margin-bottom: 1rem;
    //   }
    // }
  
  }
  
  </style>
  